export default {
  placeholder: 'Vybrať snímač',
};
